// @flow

import { type UserInputValidationError } from '@tectonics/prs/validation';

export function validateEcuadorianDocument(document: string): ?UserInputValidationError {
  if (!document) {
    return { id: 'empty'};
  } else if (!/^\d{10}$/.test(document)) {
    return { id: 'invalid-pattern' };
  }
}
